// GERAL
export const END_LOADING = "END_LOADING";

//MODULE CALENDAR
export const SET_NOW = "SET_NOW";
export const SET_PERIOD = "SET_PERIOD";
export const SET_CURRENT_DATE = "SET_CURRENT_DATE";
export const SET_OFFSET_MONTH = "SET_OFFSET_MONTH";
export const SET_OFFSET_MONTH_PICKER = "SET_OFFSET_MONTH_PICKER";

// MODULE AUTH
export const SET_AUTH_STATE = "SET_AUTH_STATE";
export const RESET_AUTH_STATE = "RESET_AUTH_STATE";
export const REFRESH_TOKEN = "REFRESH_TOKEN";

// MODULE CLINICS
export const SET_CLINICS = "SET_CLINICS";
export const RESET_CLINICS_STATE = "RESET_CLINICS_STATE";

// MODULE PROFESSIONALS
export const SET_PROFESSIONALS = "SET_PROFESSIONALS";
export const RESET_PROFESSIONALS_STATE = "RESET_PROFESSIONALS_STATE";

// MODULE SCHEDULES
export const SET_SCHEDULES = "SET_SCHEDULES";
export const RESET_SCHEDULES_STATE = "RESET_SCHEDULES_STATE";

// MODULE AGENDA
export const SET_PROFESSIONAL_AGENDA = "SET_PROFESSIONAL_AGENDA";
export const SET_PROFESSIONAL_OPTIONS = "SET_PROFESSIONAL_OPTIONS";
export const SET_SCHEDULES_AGENDA = "SET_SCHEDULES_AGENDA";
export const SET_APPOINTMENTS_AGENDA = "SET_APPOINTMENTS_AGENDA";

// MODULE RECORD
export const SET_CURRENT_TAB_RECORD = "SET_CURRENT_TAB_RECORD";
export const RESET_STATE_RECORD = "RESET_STATE_RECORD";
export const INIT_STATE_RECORD = "INIT_STATE_RECORD";
export const INIT_UPDATE_RECORD = "SET_APPOINTMENT_ID";
export const UPDATE_RECORD_ACTUATIONS = "UPDATE_RECORD_ACTUATIONS";
export const SET_RECORD_APPOINTMENT_ID = "SET_RECORD_APPOINTMENT_ID";
export const SET_RECORD_PATIENT_ID = "SET_RECORD_PATIENT_ID";
export const SET_RECORD_APPOINTMENT = "SET_RECORD_APPOINTMENT";
export const SET_RECORD_PATIENT = "SET_RECORD_PATIENT";
export const SET_HASH_APPOINTMENT = "SET_HASH_APPOINTMENT";
export const SET_HASH_PATIENT = "SET_HASH_PATIENT";

// MODULE CACHE
export const UPDATE_CACHE_PATIENTS = "UPDATE_CACHE_PATIENTS";

// MODULE USERS 
export const SET_USERS = "SET_USERS";
export const RESET_USERS_STATE = "RESET_USERS_STATE";